// removed by extract-text-webpack-plugin
module.exports = {"block":"_3Psg5pK7g6daAfOjak6MVL","title":"_1YwdXlOhVDraIMDIOh5n-w","note":"_2PYD0GULqTnuvB1znq2FQW","chart":"_1oWPzKCGMnQm5CdpZ_Uhm0","pc":"_3dVoMk0cRHjXd7PTZIILQP","sp":"RebBtqT2vVjLVX9sQ9E6H","chartWrap":"_3iWuMLBEcOepHnPVE64qrw","map":"xkgoVfRlvt7XRpxMb4Upv","mapH2":"_3_cDeSFEbu5ZLco3o-bED5","button":"_312YKujcYhm1poSQEGMvNP","link":"_2x0RrEUzXEWqAi3tSRX_DQ"};


//////////////////
// WEBPACK FOOTER
// ./src/css/screens/phaseresult.css
// module id = 97
// module chunks = 0